import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { ComoButton } from "../../Common/ComoButton";
import VoicesPostBrowser from "./VoicesPostBrowser";
import VoicesPostDialog from "./VoicesPostDialog";

interface Props {
  campaignId: number;
  canWrite: boolean;
}

const VoicesPostList: React.FC<Props> = ({ campaignId, canWrite }) => {
  const { t } = useTranslation("voicesPosts");
  const [creating, setCreating] = useState(false);

  return (
    <>
      <VoicesPostBrowser
        campaignId={campaignId}
        actions={
          canWrite && (
            <ComoButton startIcon={<AddIcon />} onClick={() => setCreating(true)}>
              {t("newPost")}
            </ComoButton>
          )
        }
      />

      <VoicesPostDialog
        open={creating}
        campaignId={campaignId}
        post={null}
        topic={null}
        onClose={() => setCreating(false)}
      />
    </>
  );
};

export default VoicesPostList;
